import {
  getJoinSuggestions,
  Request as GetJoinSuggestionsRequest,
  Response as GetJoinSuggestionsResponse,
} from "./getJoinSuggestions";
import {
  Request as SearchDatasetsRequest,
  Response as SearchDatasetsResponse,
  searchDatasets,
} from "./searchDatasets";
import { Request as VoteRequest, Response as VoteResponse, vote } from "./vote";

/** The client for datasets API calls. */
export interface DatasetsClient {
  vote: (spec: VoteRequest) => Promise<VoteResponse>;
  searchDatasets: (
    spec: SearchDatasetsRequest
  ) => Promise<SearchDatasetsResponse>;
  getJoinSuggestions: (
    request: GetJoinSuggestionsRequest
  ) => Promise<GetJoinSuggestionsResponse>;
}

export const legacyDatasetsClient: DatasetsClient = {
  vote,
  searchDatasets,
  getJoinSuggestions,
};
